import { FormikProps } from 'formik';

import { Select } from '../../../../../ui';
import { ProfileFormValues } from '../EditModal';

const jobTitles = [
    'General Adult Psychiatrist',
    'Child and Adolescent Psychiatrist',
    'Old Age Psychiatrist',
    'Addiction Psychiatrist',
    'Perinatal Pyschiatrist',
    'Forensic Psychiatrist',
    'General Practitioner (GP)',
    'Neurologist',
    'Oncologist',
    'Surgeon',
    'Cardiologist',
    'Medical Doctor (Other) / Other medical specialist',
];

export function JobTitleField({ values, setFieldValue }: FormikProps<ProfileFormValues>) {
    const options = jobTitles.map((title) => ({ label: title, value: title }));
    const value = !values.jobTitle
        ? null
        : {
              label: values.jobTitle,
              value: values.jobTitle,
          };

    return (
        <Select
            label="Professional Title*"
            name="jobTitle"
            id="jobTitle"
            value={value}
            placeholder="Please select"
            options={options}
            onChange={(option) => {
                setFieldValue('jobTitle', option?.value);
            }}
        />
    );
}
